export const COLUMN_HERADER = {
  user_listing_header: [
    {
      id: 0,
      name: "Avatar",
      width: "120px",
      selector: (row) => row.avatar,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 1,
      name: "Name",
      width: "150px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 3,
      name: "Gender",
      width: "150px",
      selector: (row) => row.gender,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 4,
      name: "Education",
      width: "150px",
      selector: (row) => row.education,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 5,
      name: "Mobile",
      width: "150px",
      selector: (row) => row.mobile,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "Email",
      width: "200px",
      selector: (row) => row.email,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 7,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
  appointment_listing_header: [
    {
      id: 0,
      name: "Id",
      width: "100px",
      selector: (row) => row.id,
      center: true,
    },
    {
      id: 0,
      name: "Name",
      width: "150px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 1,
      name: "Created Date",
      width: "180px",
      selector: (row) => row.createdAt,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 2,
      name: "Passcode",
      width: "150px",
      selector: (row) => row.passcode,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 3,
      name: "Status",
      width: "150px",
      selector: (row) => row.status,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 4,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
  agent_listing_header: [
    {
      id: 0,
      name: "Id",
      width: "100px",
      selector: (row) => row.id,
      center: true,
    },
    {
      id: 1,
      name: "Image",
      width: "150px",
      selector: (row) => row.image,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 2,
      name: "Name",
      width: "180px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    // {
    //   id: 3,
    //   name: "ID Card",
    //   width: "150px",
    //   selector: (row) => row.idCard,
    //   sortable: true,
    //   reorder: true,
    //   center: true,
    // },
    {
      id: 4,
      name: "Phone",
      width: "150px",
      selector: (row) => row.phone,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 5,
      name: "Email",
      width: "200px",
      selector: (row) => row.email,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "City",
      width: "200px",
      selector: (row) => row.city,
      sortable: true,
      reorder: true,
      center: true,
    },
    // {
    //   id: 7,
    //   name: "Address",
    //   width: "200px",
    //   selector: (row) => row.address,
    //   sortable: true,
    //   reorder: true,
    //   center: true,
    // },
    {
      id: 8,
      name: "Role",
      width: "100px",
      selector: (row) => row.role,
      sortable: true,
      reorder: true,
      center: true,
    },
    // {
    //   id: 9,
    //   name: "Gender",
    //   width: "100px",
    //   selector: (row) => row.gender,
    //   sortable: true,
    //   reorder: true,
    //   center: true,
    // },
    {
      id: 10,
      name: "Designation",
      width: "200px",
      selector: (row) => row.designation,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 11,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
  town_listing_header: [
    {
      id: 0,
      name: "Id",
      width: "100px",
      selector: (row) => row.id,
      center: true,
    },
    {
      id: 2,
      name: "Name",
      width: "180px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "City",
      width: "200px",
      selector: (row) => row.city,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 9,
      name: "Address",
      width: "100px",
      selector: (row) => row.address,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 10,
      name: "Block",
      width: "200px",
      selector: (row) => row.block,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 11,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
  blog_listing_header: [
    {
      id: 0,
      name: "Id",
      width: "100px",
      selector: (row) => row.id,
      center: true,
    },
    {
      id: 2,
      name: "Name",
      width: "180px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 2,
      name: "Image",
      width: "180px",
      selector: (row) => row.image,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "Description",
      width: "200px",
      selector: (row) => row.description,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 11,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
  rate_listing_header: [
    {
      id: 0,
      name: "Id",
      width: "100px",
      selector: (row) => row.id,
      center: true,
    },
    {
      id: 2,
      name: "Town",
      width: "180px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "Plot",
      width: "250px",
      selector: (row) => row.plot,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 11,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
  propertyRate_listing_header: [
    {
      id: 0,
      name: "Id",
      width: "100px",
      selector: (row) => row.id,
      center: true,
    },
    {
      id: 2,
      name: "Marla",
      width: "100px",
      selector: (row) => row.marla,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 2,
      name: "Price",
      width: "100px",
      selector: (row) => row.price,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "Location",
      width: "300px",
      selector: (row) => row.address,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "Type",
      width: "100px",
      selector: (row) => row.type,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 11,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
  construction_listing_header: [
    {
      id: 0,
      name: "Id",
      width: "100px",
      selector: (row) => row.id,
      center: true,
    },
    {
      id: 2,
      name: "Project Name",
      width: "180px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 2,
      name: "Town",
      width: "180px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "Image",
      width: "200px",
      selector: (row) => row.city,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "Address",
      width: "200px",
      selector: (row) => row.city,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 11,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
  maps_listing_header: [
    {
      id: 0,
      name: "Id",
      width: "100px",
      selector: (row) => row.id,
      center: true,
    },
    {
      id: 2,
      name: "Town",
      width: "280px",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
      center: true,
    },
    {
      id: 6,
      name: "Image",
      width: "280px",
      selector: (row) => row.city,
      sortable: true,
      reorder: true,
      center: true,
    },

    {
      id: 11,
      name: "Action",
      width: "200px",
      selector: (row) => row.action,
      sortable: true,
      reorder: true,
      center: true,
    },
  ],
};
